import axios from 'axios';

import {
  MediaResponse,
  ResourceResponse
} from '../types/responses/media-response';
import { Resource } from '../types/game-document';
import { ApiBaseUrl, DeleteAsync, GetBearerHeader, PostFileAsync } from './api';

const MediaEndpoint = `media`;

/**
 * Applies a POST form data.
 * @param file - file upload
 * @returns the media object
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/POST
 */
export const PostMediaAsync = async (file: File) =>
  PostFileAsync<MediaResponse>(`${MediaEndpoint}`, file);

/**
 * Delete media based on mediaid
 * @param endpoint - the API V2 Endpoint for entity DELETE
 * @returns the deleted media object.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/DELETE
 */
export const DeleteMediaAsync = async (mediaId: number) =>
  DeleteAsync<MediaResponse>(`${MediaEndpoint}/${mediaId}`);

/**
 * Applies a POST form data.
 * @param file - file upload
 * @returns the resource object
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/POST
 */
export const PostResourceAsync = async (file: File | Blob) => {
  const response = await PostFileAsync<ResourceResponse>(
    `${MediaEndpoint}/resources`,
    file
  );
  //cast to resource
  return {
    name: response.name!,
    value: response.url!,
    thumbnailValue: response.thumbnailUrl!,
    type: response.type!,
    size: response.contextSize
  } as Resource;
};

export const PostResourceAsyncWithProgress = async (
  file: File | Blob,
  onProgress: (percent: number) => void
) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data: response } = await axios.post<ResourceResponse>(
    `${ApiBaseUrl}/${MediaEndpoint}/resources`,
    formData,
    {
      headers: {
        ...GetBearerHeader()
      },
      onUploadProgress: (evt) => {
        if (evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      }
    }
  );

  return {
    name: response.name!,
    value: response.url!,
    thumbnailValue: response.thumbnailUrl!,
    type: response.type!,
    size: response.contextSize
  } as Resource;
};
